// extracted by mini-css-extract-plugin
export var container = "_1x-0";
export var disabled = "_1x-4";
export var fullWidth = "_1x-3";
export var lined = "_1x-1";
export var selected = "_1x-5";
export var tab = "_1x-2";